import React from 'react';

function ContactAddress() {
  return (
	  	<div className="col-xl-5 col-lg-6 col-md-8">
                <div className="contact-info-wrap">
                  <div className="contact-img">
                    <img src="img/images/contact_img.png" alt="" />
                  </div>
                  <div className="contact-info-list">
                    <ul>
                      <li>
                        <div className="icon" ><i className="fas fa-map-marker-alt"  /></div>
                        <div className="content">
                          <p>127 avenue Jugurtha, Mutuelleville, 1082 Tunis, Tunisie</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon"><i className="fas fa-phone-alt" /></div>
                        <div className="content">
                          <p>+216 90 117 027</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon"><i className="fas fa-clock" /></div>
                        <div className="content">
                          <p>09:00 - 20:00 / 7j/7</p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="contact-social">
                    <ul>
                      <li><a href="/#"><i className="fab fa-facebook-f" /></a></li>
                      <li><a href="/#"><i className="fab fa-instagram" /></a></li>
                    </ul>
                  </div>
                </div>
              </div>

  )
}

export default ContactAddress;
